// extracted by mini-css-extract-plugin
export default {"processor":"ProcessorIcon_processor__TV5+F","processor__P":"ProcessorIcon_processor__P__e+bLx"};